import React from "react";
import Icon from "../../../components/AppIcon.jsx";
import Button from "../../../components/ui/Button.jsx";

const footerData = {
  name: "Rehmat Ullah",
  tagline: "Front-End Developer · React js Angular Specialist · Open to Opportunities",
  resumeUrl: "/Rehmat Ullah Resume (2).pdf",
  githubStats: [
    { label: "Public Repos", value: "100" },
    { label: "Total Stars", value: "80+" },
    { label: "Contributions", value: "280+" },
    { label: "Followers", value: "20+" },
  ],
  links: [
    { label: "About", href: "#about" },
    { label: "Skills", href: "#skills" },
    { label: "Projects", href: "#projects" },
    { label: "Experience", href: "#experience" },
    { label: "Contact", href: "#contact" },
  ],
  socials: [
    { name: "GitHub", icon: "Github", url: "https://github.com/rehmatcodemaster" },
    { name: "Fiver", icon: "Fiverr", url: "https://www.fiverr.com/seller_onboarding/0" },
    { name: "Instagram", icon: "Instagram", url: "https://www.instagram.com/rehmat_ullah7786/" },
    { name: "Email", icon: "Mail", url: "mailto:rehmat.ullah.network@gmail.com" },
  ],
};

export default function FooterSection() {
  const scrollToSection = (href) => {
    const id = href?.replace("#", "");
    const el = document.getElementById(id);
    if (el) el?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer style={{ background: "#0A0A0C", color: "var(--color-foreground)", borderTop: "1px solid var(--color-border)" }}>
      {/* Main Footer */}
      <div className="max-w-6xl mx-auto px-4 md:px-6 lg:px-8 py-12 md:py-16">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          {/* Brand */}
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-3 mb-4">
              <div
                className="w-10 h-10 flex items-center justify-center rounded-xl"
                style={{ background: "var(--color-primary)", boxShadow: "0 0 16px rgba(124,106,247,0.4)" }}
              >
                <span className="text-sm font-bold text-white" style={{ fontFamily: "var(--font-heading)" }}>RU</span>
              </div>
              <span className="text-lg font-bold" style={{ fontFamily: "var(--font-heading)", color: "var(--color-foreground)" }}>
                {footerData?.name}
              </span>
            </div>
            <p className="text-sm mb-6 max-w-xs" style={{ color: "var(--color-muted-foreground)", fontFamily: "var(--font-body)" }}>
              {footerData?.tagline}
            </p>
            <a href={footerData.resumeUrl} download="Rehmat-Ullah-Resume.pdf">
              <Button
                variant="outline"
                size="sm"
                iconName="Download"
                iconPosition="left"
              >
                Download Resume
              </Button>
            </a>
          </div>

          {/* GitHub Stats */}
          <div className="flex-shrink-0">
            <h3 className="text-xs font-semibold uppercase tracking-wider mb-4" style={{ color: "var(--color-muted-foreground)", fontFamily: "var(--font-caption)" }}>
              GitHub Activity
            </h3>
            <div className="grid grid-cols-2 gap-3">
              {footerData?.githubStats?.map((stat) => (
                <div
                  key={stat?.label}
                  className="p-3 rounded-xl text-center"
                  style={{ background: "rgba(124,106,247,0.06)", border: "1px solid rgba(124,106,247,0.15)" }}
                >
                  <div className="text-xl font-bold mb-0.5" style={{ fontFamily: "var(--font-data)", color: "var(--color-primary)" }}>
                    {stat?.value}
                  </div>
                  <div className="text-xs" style={{ color: "var(--color-muted-foreground)", fontFamily: "var(--font-caption)" }}>
                    {stat?.label}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Navigation */}
          <div className="flex-shrink-0">
            <h3 className="text-xs font-semibold uppercase tracking-wider mb-4" style={{ color: "var(--color-muted-foreground)", fontFamily: "var(--font-caption)" }}>
              Navigation
            </h3>
            <ul className="space-y-2">
              {footerData?.links?.map((link) => (
                <li key={link?.label}>
                  <button
                    onClick={() => scrollToSection(link?.href)}
                    className="text-sm transition-colors duration-200 hover:text-primary"
                    style={{ color: "var(--color-muted-foreground)", fontFamily: "var(--font-body)", background: "none", border: "none", cursor: "pointer", padding: 0 }}
                  >
                    {link?.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      {/* Bottom Bar */}
      <div
        className="border-t"
        style={{ borderColor: "var(--color-border)" }}
      >
        <div className="max-w-6xl mx-auto px-4 md:px-6 lg:px-8 py-4 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs" style={{ color: "var(--color-muted-foreground)", fontFamily: "var(--font-caption)" }}>
            © {new Date()?.getFullYear()} Rehma Ullah. All rights reserved.
          </p>
          <div className="flex gap-3">
            {footerData?.socials?.map((s) => (
              <a
                key={s?.name}
                href={s?.url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={s?.name}
                className="w-8 h-8 flex items-center justify-center rounded-lg border transition-all duration-200 hover:border-primary hover:bg-primary/10"
                style={{ borderColor: "var(--color-border)" }}
              >
                <Icon name={s?.icon} size={16} color="var(--color-muted-foreground)" />
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}